<template>
  <div class="popupBackdrop">
    <div class="popupContainer">
      
      <div class="popupLeft">
        <div class="imageContainer">
          <img src="@/assets/images/ian_contact_popup.jpg" alt="">
        </div>
        <div class="infoBlock">
          <div class="infoBlock-title">Contact Information</div>
          <div class="infoBlock-name">Ian Hurdle</div>
          <div class="infoBlock-email">
            <SvgComponent name="email" />
            <a href="mailto:ian.hurdle@theagencyre.com">ian.hurdle@theagencyre.com</a>
          </div>
          <div class="infoBlock-phone">
            <SvgComponent name="phone" />
            <a href="tel:6492471993">6492471993</a></div>
        </div>
        
      </div>
      <div class="popupRight">
        <div class="close" @click="$store.commit('toggleContactPopupOpen', false);">
          <img src="@/svg/close.svg" alt="">
        </div>
        <div class="logo">
          <img src="@/svg/logo.svg" alt="">
        </div>
        <div class="form-mainFields">
          <div class="form-inputGroup" :class="{ _error: $v.firstName.$error }">
            <label class="form-label">First Name *</label>
            <input class="form-input" v-model.trim="$v.firstName.$model">
            <div class="error" v-if="$v.firstName.$error && !$v.firstName.required">Please enter the name</div>
          </div>

          <div class="form-inputGroup">
            <label class="form-label">Last Name</label>
            <input class="form-input" v-model.trim="$v.lastName.$model">
          </div>

          <div class="form-inputGroup" :class="{ _error: $v.email.$error }">
            <label class="form-label">E-mail *</label>
            <input class="form-input" v-model.trim="$v.email.$model">
            <div class="error" v-if="$v.email.$error && !$v.email.required">Please enter the email</div>
            <div class="error" v-if="$v.email.$error && !$v.email.email">Enter a valid email address</div>
          </div>

          <div class="form-inputGroup" :class="{ _error: $v.phone.$error }">
            <label class="form-label">Phone</label>
            <input class="form-input" v-model.trim="$v.phone.$model">
          </div>
        </div>
        <div class="form-secondaryFields">
        <div class="form-inputGroup" :class="{ _error: $v.message.$error }">
            <label class="form-label">Message *</label>
            <input class="form-input" v-model.trim="$v.message.$model">
            <div class="error" v-if="$v.message.$error && !$v.message.required">Please enter the request</div>
          </div>
        </div>


      <div class="checkbox-wrapper">
        <input type="checkbox" id="terms" name="terms" v-model="terms">
          <label for="terms">
            <span class="checkbox-custom"></span>
            By providing your contact information, you agree to our <a href="/privacy-policy">Privacy Policy</a> and consent 
            to receive marketing communications (calls, texts, emails — some automated). Consent isn’t required 
            to purchase, and you can opt out anytime. Reply STOP to texts or use the unsubscribe link in emails. 
            Message/data rates may apply.</label>
      </div>

      <div class="submit-button">
        <button class="button" @click="submit()" :disabled="!terms || $v.$invalid" >Send Request</button>
      </div>
       
      </div>
    </div>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, email } from 'vuelidate/lib/validators';
  import SvgComponent from './SvgComponent.vue';


  export default {   
    mixins: [validationMixin],

    
    
    data(){
      
      return {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
        terms: false,
      }
    },

    methods: {
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        await this.$store.dispatch('sendEmail', {
          name: `${this.firstName} ${this.lastName}`.trim(),
          email: this.email,
          phone: this.phone,
          message: this.message,
        });
        this.$store.commit('toggleContactPopupOpen', false);
        this.$router.push({ name: 'SuccessPage' });
      },
    },
    validations: {
      firstName: { required },
      lastName: {},
      email: { required, email },
      phone: {},
      message: { required },
    },

    components: {
        SvgComponent
    },
  };
</script>

<style lang="scss">
  // @import "@/styles/settings.scss";

  .popupBackdrop {    
    position: fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 100;
    top: 0;
    left: 0;

    .popupContainer {
      width: 1240px;
      height: 745px;
      background-color: #FFFAF3;
      display:grid;
      grid-template-columns: 1fr 1.5fr;

      @include phone {
        grid-template-columns: 1fr;
        width: 100%;
        height: 100%;
      }


      .popupLeft {
        position: relative;

        @include phone {
          display: none;
        }

        .imageContainer {
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .infoBlock {
          position: absolute;
          bottom: 64px;
          left: 64px;
          color: white;
          font-size: 18px;
          line-height: 24px;

          &-title {
            font-weight: 700;
            font-size: 24px;
            line-height: 36px;
            margin-bottom: 16px;
          }
          &-name {
            font-weight: 700;
            font-size: 18px;
            margin-bottom: 10px;
          }
          &-email {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 10px;
           
          }

          &-phone {
            display: flex;
            align-items: center;
            gap: 6px;
          }

           svg {
              transform: scale(0.7);
              filter: brightness(0) invert(1);

            }

        }
      }
      .popupRight {
        position: relative;
        width: 100%;
        padding: 120px 60px;

        @include phone {
          padding: 100px 16px 0; 
        }

        .close {
          position: absolute;
          top: 30px;
          right: 30px;
          cursor: pointer;

          @include phone {
            top: 16px;
            right: 16px;
          }
        }
        
        .logo {
          position: absolute;
          top: 16px;
          left: 16px;
          width: 93px;
          height: 48px;
          display: none;
          @include phone {
            display: block;
          }
          
          img {
            width: 100%;
            height: 100%;
          }
        }
      
      }
    }

  .form-mainFields {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 40px;
    row-gap: 14px;

    @include phone {
      grid-template-columns: 1fr;
    }
  }

  .form-secondaryFields {
    margin-top: 14px;
    
  }

  .form-inputGroup {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 27px;

    label {
      font-size: 18px;
      line-height: 18px;
      font-weight: 700;
      color: #1F1E1E;
      margin-bottom: 8px;
    }

    input {
      padding: 8px 0;
      border-bottom: 1px solid #1F1E1E;
      font-size: 18px;
    }
    &._error {
      border-color: $red !important;
    }
    .error {
      position: absolute;
      bottom: -1.5em;
      font-size: 16px;
      line-height: 19px;
      color: $red;
    }
  }

.checkbox-wrapper {

  padding-top: 14px;

  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;

    &:checked + label .checkbox-custom {
      background: #000;
      border-color: #000;
      
      &::after {
        content: '';
        position: absolute;
        left: 5px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }

  label {
    display: block;
    cursor: pointer;
    padding-left: 30px;
    position: relative;
    font-size: 14px;
    line-height: 16px;
    a {
      font-weight: 700;
      &:hover {
        color: $red;
        text-decoration: underline;
      }
    }
  }

  .checkbox-custom {
    position: absolute;
    left: 0;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 2px solid #c4c4c4;
    border-radius: 2px;
  }
}

 .submit-button {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;

  &._disabled {
    opacity: 0.5;
    pointer-events: none;
  }
   
  button{
    width: 100%;
    background: #1F1E1E;
    color: white;
    font-size: 20px;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover {
      background: $red;
      color: white;
    }
  }
 }

    @include tablet {
      
    }
    @include phone {
      
    }
  }

</style>
